import {HttpClient} from "../../service/httpClient/HttpClient";

export class ManagerService {
    constructor() {
        this.httpClient = new HttpClient()
    }

    getManagerList(page, size) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `admins`,
                {page, size}
            ).then(resolve).catch(reject)
        })
    }

    addNewManager(firstName, lastName, phoneNumber, username, password) {

        let formData = new URLSearchParams()
        formData.append("firstName", firstName)
        formData.append("lastName", lastName)
        formData.append("phoneNumber", phoneNumber)
        formData.append("username", username)
        formData.append("password", password)

        const config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }

        return new Promise((resolve, reject) => {
            new HttpClient(
                {},
                'application/x-www-form-urlencoded'
            ).post(
                `admins`,
                formData
            ).then(resolve).catch(reject)
        })

    }
}